
//Valentine's Offer text direct static replacement

// (function () {
//   var OLD_TEXTS = [
//     "🥳 Our Anniversary Sale Is Live Now! 🥳",
//     "🥳 Our Anniversary Sale Is On! 🥳",
//     "🥳 Anniversary Sale is On! 🥳"
//   ];
//  // var NEW_TEXT = "❤️ Our Valentine's Sale Is Live Now! ❤️";
//   // var NEW_TEXT = "Our Easter Sale Is Live Now 🐰🐣";
//   // var NEW_TEXT = "🕵️ Our Mystery May Sale Is Now Live! 🕵️";
//   // var NEW_TEXT = "🤸🎈 Our Play Days Sale Is Now Live 🎈👩🏼‍🤝‍👨🏽";
//   var NEW_TEXT = "🎒✨ The Smart Start Sale Is Now Live ✨📚";

//   function replaceText(root) {
//     var scope = root || document;

//     scope
//       .querySelectorAll("h1,h2,h3,h4,h5,h6,#seasonalSale")
//       .forEach(function (el) {
//         if (OLD_TEXTS.includes(el.textContent.trim())) {
//           el.textContent = NEW_TEXT;
//         }
//       });
//   }

//   replaceText();

//   if (window.MutationObserver) {
//     new MutationObserver(function (mutations) {
//       mutations.forEach(function (m) {
//         if (m.type === "childList" || m.type === "characterData") {
//           replaceText(m.target.nodeType === 1 ? m.target : m.target.parentNode);
//         }
//       });
//     }).observe(document.body, {
//       childList: true,
//       subtree: true,
//       characterData: true
//     });
//   }
// })();

(function () {
  var currentDate = new Date();
  var year = currentDate.getFullYear();

  // Active period: October 19 to October 25 (inclusive)
  var startDate = new Date(year, 9, 19, 0, 0, 0);
  var endDate = new Date(year, 9, 26, 0, 0, 0);

  // Stop completely outside the active period
  if (currentDate < startDate || currentDate >= endDate) {
    return;
  }

  var OLD_TEXTS = [
    "🥳 Our Anniversary Sale Is Live Now! 🥳",
    "🥳 Our Anniversary Sale Is On! 🥳",
    "🥳 Anniversary Sale is On! 🥳"
  ];

  var NEW_TEXT =
    "🤸🎈The Big Kiddo Sale is now LIVE ! 🎈👩🏼‍🤝‍👨🏽";

  function replaceText(root) {
    var scope = root || document;

    if (scope.nodeType === 1 &&
        scope.matches("h1,h2,h3,h4,h5,h6,#seasonalSale") &&
        OLD_TEXTS.includes(scope.textContent.trim())) {
      scope.textContent = NEW_TEXT;
    }

    if (scope.querySelectorAll) {
      scope
        .querySelectorAll("h1,h2,h3,h4,h5,h6,#seasonalSale")
        .forEach(function (el) {
          if (OLD_TEXTS.includes(el.textContent.trim())) {
            el.textContent = NEW_TEXT;
          }
        });
    }
  }

  replaceText();

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === "childList" || m.type === "characterData") {
          var target =
            m.target.nodeType === 1
              ? m.target
              : m.target.parentNode;

          if (target) {
            replaceText(target);
          }
        }
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
})();






// (function() {

//   // var NEW_HEADING_TEXT = "🎉 Our Cyber Monday Sale Is Live Now! 🥳";
//   // var NEW_HEADING_HTML = '🎉 Our <span class="black-friday-allproducts">Cyber Monday</span> Sale Is Live Now! 🥳';

//   var NEW_HEADING_TEXT = "🎄 Our Anniversary Sale Is Live Now! 🎅";
//   var NEW_HEADING_HTML = '🎄 Our <span class="black-friday-allproducts">Anniversary</span> Sale Is Live Now! 🎅';


//   function replaceAnniversaryHeadings(root) {
//     var headings = (root || document).querySelectorAll("h1,h2,h3,h4,h5,h6");

//     headings.forEach(function(h) {
//       var txt = (h.textContent || "").trim();
//       if (!txt) return;
//       var lower = txt.toLowerCase();

//       if (
//         lower.includes("anniversary sale is on") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (
//         lower.includes("today") &&
//         lower.includes("anniversary") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         var newText = txt.replace(/is our\s+anniversary!?/i, "is our Anniversary Sale!");
//         newText = newText.replace(
//           /is our Anniversary Sale!/,
//           'is our <span class="black-friday-allproducts">Anniversary</span> Sale!'
//         );

//         newText = newText.replace(/🎉/g, "🎄").replace(/🥳/g, "🎅");

//         h.innerHTML = newText;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (txt === NEW_HEADING_TEXT && !h.querySelector(".black-friday-allproducts")) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//       }
//     });
//   }

//   function startReplacing() {
//     replaceAnniversaryHeadings(document);
//     var attempts = 0;
//     var intervalId = setInterval(function() {
//       replaceAnniversaryHeadings(document);
//       if (++attempts > 30) clearInterval(intervalId);
//     }, 500);

//     if (window.MutationObserver) {
//       new MutationObserver(function(mutations) {
//         mutations.forEach(function(m) {
//           m.addedNodes.forEach(function(node) {
//             if (node.nodeType === 1) replaceAnniversaryHeadings(node);
//           });
//         });
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", startReplacing);
//   } else {
//     startReplacing();
//   }

// })();
